<template>
  <div
    v-if="showLoadingState < 5"
    key="loadingState"
    :class="['o-edition-section-content', $store.getters.getIsClientData === false
      ? 'o-edition-section-content-upgrade' : '']"
  >
    <AtomLoadingPrimary/>
  </div>
  <div
    v-else
    key="sectionContent"
    :class="['o-edition-section-content', $store.getters.getIsClientData === false
      ? 'o-edition-section-content-upgrade' : '']"
  >
    <MoleculeEditionSectionContentInfo
      :element="element"
      :go-back-text="goBackText"
      :info-title="infoTitle"
      :info-sub-title="infoSubTitle"
      :section="section"
      :subject="subject"
    />
    <MoleculeEditionSectionContentSubject
      :is="molecule"
      :element="element"
      :element-categorias="elementCategorias"
      :contenido="contenidos[0]"
    />
    <MoleculeEditionSectionContentFooter/>
  </div>
</template>

<script>
export default {
  name: 'OrganismEditionSectionContent',

  components: {
    MoleculeEditionSectionContentInfo: () => import('@/components/molecules/MoleculeEditionSectionContentInfo'),
    MoleculeEditionSectionContentFooter: () => import('@/components/molecules/MoleculeEditionSectionContentFooter')
  },

  data () {
    return {
      contenidoNodos: [],
      contenidos: [],
      element: {},
      elementCategorias: [],
      goBackText: '',
      infoSubTitle: '',
      infoTitle: '',
      inscripcionNodos: [],

      filter: {
        tipo: 0
      },

      molecule: '',
      showLoadingState: 0,
      subject: '',
      subedition: ''
    }
  },

  computed: {
    elementName () {
      return this.$route.meta.isEdition === 'asset' ? this.element.titulo : ''
    },

    section () {
      return this.$utils.stringCapitalized(this.$route.meta.isEdition)
    },

    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    $route () {
      this.getMolecule()
      this.$utils.hideAsideNavigationMenu()
    },

    '$route.params.id' () {
      this.$store.commit('unsetProyect')
      this.$store.commit('unsetSelectedNode')
      this.$store.commit('unsetSelectedProyect')
      this.$store.commit('unsetProyectNodes')
      this.$store.commit('unsetProyectNodesEnrollment')
      this.readElement()
    },

    updatedData () {
      if (this.$modal.methodToRun === 'readElement') {
        this.readElement()
      } else if (this.$modal.methodToRun === 'readInscripcionNodos') {
        this.readInscripcionNodos()
      }
    }
  },

  created () {
    this.setInitialStates()
    this.getMolecule()
    this.readElement()
    this.$utils.hideAsideNavigationMenu()
  },

  methods: {
    getMolecule () {
      this.setInitialStates()
      let menu = this.$i18n.messages[this.$i18n.locale].mEditionMenu[this.$route.meta.isEdition]
      for (const item in menu) {
        if (menu[item].subject === this.$route.params.subject) {
          this.infoTitle = menu[item].text
          this.subject = this.$utils.stringCapitalized(item)
          for (const child in menu[item].children) {
            if (menu[item].children[child].subedition === this.$route.params.subedition) {
              this.goBackText = menu[item].children[child].goBackText
              this.infoSubTitle = menu[item].children[child].text
              this.subedition = this.$utils.stringCapitalized(child)
              break
            }
          }
          break
        }
      }

      this.molecule = this.$route.meta.isEdition === 'asset'
        ? () => import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}`)
        : this.$route.params.subedition
          ? () => import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}${this.subedition}`)
          : () => import(`@/components/molecules/MoleculeEdition${this.section}${this.subject}`)
      this.showLoadingState++
    },

    getNodoActivo (nodos, nodoId) {
      for (let i = 0; i < nodos.length; i++) {
        if (nodoId !== null && nodos[i].id === nodoId) {
          this.$store.commit('setSelectedNode', nodos[i])
          break
        } else if (nodoId === null && nodos[i].texto && this.inscripcionNodos.find(inodo => inodo.nodo === nodos[i].id) !== undefined) {
          this.$store.commit('setSelectedNode', nodos[i])
          break
        } else if (nodos[i].children.length) {
          this.getNodoActivo(nodos[i].children, nodoId)
        }
      }
    },

    readContenidoNodos () {
      this.$services.read('contenido', 'readContenidoNodos', {}, [this.contenidos[0].id])
        .then(response => {
          this.contenidoNodos = response.data
          // TODO: filtrar nodos activos para evitar v-show="activo" en MoleculeEditionAssetContentsTreeNode
          this.$store.commit('setProyectNodes', this.contenidoNodos)
          this.readInscripcionNodos()
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readElement () {
      if (this.$route.meta.isEdition === 'asset') {
        this.readInscripcionActivaByProyectoAlumno()
      } else {
        this.showLoadingState += 4
      }
    },

    readInscripcionActivaByProyectoAlumno () {
      this.$services.read('inscripcion', 'readInscripcionActivaByProyectoAlumno', {}, [this.$route.params.id])
        .then(response => {
          this.$store.commit('setSelectedProyect', response.data.inscripcion)
          this.element = response.data.inscripcion
          this.contenidos = [response.data.contenido]
          this.$store.commit('setProyectContents', [response.data.contenido])
          this.showLoadingState++
          this.showLoadingState++
          this.readContenidoNodos()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readInscripcionNodos () {
      this.$services.read('inscripcion', 'readInscripcionNodos', {}, [this.element.id_inscripcion])
        .then(response => {
          if (response.data.length) {
            this.inscripcionNodos = response.data
            this.$store.commit('setProyectNodesEnrollment', this.inscripcionNodos)
            let nodoId = this.$route.params.subid ? this.$route.params.subid : null
            this.getNodoActivo(this.contenidoNodos, nodoId)
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    setInitialStates () {
      this.infoTitle = ''
      this.infoSubTitle = ''
      this.goBackText = ''
    }
  }
}
</script>
